<footer>
  @if (showActions$ | async) {
  <nav>
    <ul>
        @if (features.showAccessibilityStatement) {
          <li>
            <a
              [routerLink]="['/accessibility-statement']"
              [queryParams]="{ returnUrl: returnUrl$ | async }"
            >
              Accessibility Statement
            </a>
          </li>
        }
        @if (login$ | async; as $) {
          @if ($.isLoggedIn) {
            <li>
              <a [routerLink]="['/profile']">Profile</a>
            </li>
            <li>
              <a [routerLink]="['/logout']">Logout</a>
            </li>
          } @else {
            <li>
              <a [routerLink]="['/login']">Login</a>
            </li>
          }
        }
        @if (features.helpUrl) {
          <li>
            <a target="_blank" rel="noopener" [href]="features.helpUrl">
              Help
              <span class="sr-only">(External Link, opens in a new tab or window)</span>
            </a>
          </li>
        }
      </ul>
    </nav>
  }
  <div class="copyright">
    Copyright &copy; {{ currentYear }} {{ companyName }}
    <br>
    <ng-container *ngIf="version">Version: {{ version }} </ng-container>
    <ng-container *ngIf="snapshotInfo$ | async as snapshotInfo">({{ snapshotInfo?.buildId }})</ng-container>
  </div>
</footer>
